module.exports = __webpack_public_path__ + "img/观众数.d412975d.png";